/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadingEntry
 */
export interface ReadingEntry {
    /**
     * 
     */
    label?: string;
    /**
     * 
     */
    numericValue?: number;
    /**
     * 
     */
    textValue?: string;
    /**
     * 
     */
    statusValue?: ReadingEntryStatusValueEnum;
}


/**
 * @export
 */
export const ReadingEntryStatusValueEnum = {
    Pass: 'PASS',
    Fail: 'FAIL',
    Warning: 'WARNING',
    NotApplicable: 'NOT_APPLICABLE',
} as const;
export type ReadingEntryStatusValueEnum = typeof ReadingEntryStatusValueEnum[keyof typeof ReadingEntryStatusValueEnum];


/**
 * Check if a given object implements the ReadingEntry interface.
 */
export function instanceOfReadingEntry(value: object): value is ReadingEntry {
    return true;
}

export function ReadingEntryFromJSON(json: any): ReadingEntry {
    return ReadingEntryFromJSONTyped(json, false);
}

export function ReadingEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadingEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'numericValue': json['numericValue'] == null ? undefined : json['numericValue'],
        'textValue': json['textValue'] == null ? undefined : json['textValue'],
        'statusValue': json['statusValue'] == null ? undefined : json['statusValue'],
    };
}

export function ReadingEntryToJSON(json: any): ReadingEntry {
    return ReadingEntryToJSONTyped(json, false);
}

export function ReadingEntryToJSONTyped(value?: ReadingEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'numericValue': value['numericValue'],
        'textValue': value['textValue'],
        'statusValue': value['statusValue'],
    };
}

